import { FormField, getAccountUrl, handleRequestError, InfoBox, Logger, settings, useUser } from '@desp-aas/desp-ui-fwk';
import { useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import { UpdateUserEmail } from '../UpdateUserEmail/UpdateUserEmail';

const logger = new Logger("component", "UserAccount");

export const UserAccount = () =>{
    const user = useUser();

    const handleManageAccount = useCallback(async () => {
        
        try {
            const response = await getAccountUrl();
            window.open(response.redirect_url, '_blank');
        } catch (error: any) {
            logger.error('Error during account management redirect', error);
            handleRequestError(error, { defaultMessage: 'An error occurred while accessing account management' });
        }
    }, []);


    return (
        <>
            <div className="user-profile-asset">
                <h2>account details</h2>

                <InfoBox type="info" title="Personal information policy" small>
                    <>
                    <p>
                        
                        For more information about how we handle your personal data, please refer to 
                        our <NavLink to={settings.privacyPoliciesPath}>privacy policy</NavLink>.
                    </p>
                    </>
                </InfoBox>
                <br/>

                <UpdateUserEmail />
                <FormField
                    label="Username"
                    value={user?.username}
                    disabled
                    onUpdate={()=>{}}
                />
                <FormField
                    label="Full name"
                    value={user?.displayName}
                    disabled
                    onUpdate={()=>{}}
                />
                
                <div 
                    className="flex-end"
                >
                    <div 
                        className="button themed medium"
                        onClick={handleManageAccount}
                    >
                        Manage account
                    </div>
                </div>
            </div>
        </>

    )
}
